import {type RefObject, useEffect, useState} from 'react';

const PINNED_TOLERANCE_PX = 1;

export function useIsPinnedToTop(ref: RefObject<HTMLElement | null>, enabled = true) {
  const [isPinned, setIsPinned] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!enabled || !element) {
      setIsPinned(false);
      return;
    }

    let frame = 0;
    const update = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const stickyTop = parseFloat(getComputedStyle(element).top) || 0;
        const isSticky = getComputedStyle(element).position === 'sticky';
        const isScrolled = (document.scrollingElement?.scrollTop ?? window.scrollY) > 0;
        setIsPinned(
          isSticky &&
            isScrolled &&
            element.getBoundingClientRect().top <= stickyTop + PINNED_TOLERANCE_PX,
        );
      });
    };

    update();
    document.addEventListener('scroll', update, {capture: true, passive: true});
    window.addEventListener('resize', update);
    return () => {
      document.removeEventListener('scroll', update, {capture: true});
      window.removeEventListener('resize', update);
      cancelAnimationFrame(frame);
    };
  }, [ref, enabled]);

  return isPinned;
}
